import { AvvirEvent } from "type_aliases";
import AutodeskIssueTypes from "../../models/api/autodesk_issue_types";

export type AutodeskIssueTypesLoadedEvent = AvvirEvent<typeof AUTODESK_ISSUE_TYPES_LOADED, AutodeskIssueTypes[]>

const autodeskIssueTypesLoaded = (issueTypes: AutodeskIssueTypes[]): AutodeskIssueTypesLoadedEvent => ({
  type: AUTODESK_ISSUE_TYPES_LOADED,
  payload: issueTypes
});

export const AUTODESK_ISSUE_TYPES_LOADED = "autodesk_issue_types_loaded";

export default autodeskIssueTypesLoaded;